var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.isMobile()
      ? _c("div", { class: ["slider-mobile"] }, [
          _c("div", { ref: "mobileSwiper", staticClass: "swiper-container" }, [
            _c("div", { staticClass: "presentation__controls" }, [
              _c("div", { staticClass: "presentation__arrows" }, [
                _c("div", {
                  staticClass: "swiper-button-prev presentation__button-prev",
                  class: !_vm.canSwipeSlide(-1)
                    ? "presentation__button-prev_disabled"
                    : "",
                  domProps: {
                    innerHTML: _vm._s(require("../img/arrow-right.svg")),
                  },
                  on: { click: _vm.firePreviousSlide },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "swiper-button-next presentation__button-next",
                  class: !_vm.canSwipeSlide(1)
                    ? "presentation__button-next_disabled"
                    : "",
                  domProps: {
                    innerHTML: _vm._s(require("../img/arrow-right.svg")),
                  },
                  on: { click: _vm.fireNextSlide },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.slides, function (slide) {
                return _c(
                  "div",
                  { key: _vm.slides.id, staticClass: "swiper-slide" },
                  [_vm._t("slide", null, { slide: slide })],
                  2
                )
              }),
              0
            ),
          ]),
        ])
      : _c(
          "div",
          { class: ["slider-desktop"] },
          [
            _vm._l(_vm.slides, function (slide) {
              return [_vm._t("slide", null, { slide: slide })]
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }